import ReactDom from 'react-dom'
import { useEffect, useState } from 'react'
import { useFireStore, useStorage, timestamp } from '../../firebase/firebase'
import { useTranslation } from "react-i18next";
import { usePosition } from 'use-position';
import { useAuth } from 'context/AuthContext'
import { format } from 'date-fns'

import { Close } from 'components/misc/Icons'

export default function ModalEditPost({open, onClose, id}) {

    const {t, i18n} = useTranslation('common');

    // post State
    const [tag, setTag] = useState([]);
    const [post, setPost] = useState('')
    const [file, setFile] = useState(null)

    const { currentUser } = useAuth()

    async function getPost() {
        const postRef = await useFireStore
        .collection('posts')
        .doc(id);
        const doc = await postRef.get();
        if (!doc.exists) {
            console.log('No such post');
        } else {
            const newData = doc.data();
            setTag(newData.tag)
            setPost(newData.post)
        }
    }

    useEffect(() => {
        getPost();
    },[])

    async function editPost(e) {
        e.preventDefault()
        try {
            return await useFireStore
            .collection('posts')
            .doc(id)
            .update({
                tag: tag,
                post: post,
            });
        }
        catch {
            console.log('Failed to edit. Please try again and that.')
        }

        finally {
             console.log('Post has been edited')
        }
    }

    if (!open) return null

    return ReactDom.createPortal(
        <div className="fixed top-0 bottom-0 left-0 right-0 z-1100" style={{backgroundColor: 'rgba(0, 0, 0, .7)'}}>
            <div className="fixed p-4 rounded-lg border-borderlight dark:border-borderdark bg-bglight dark:bg-bgdark w-190 z-1100" style={{top: '50%',left: '50%',transform: 'translate(-50%, -50%)'}}>

                <div className="flex flex-row items-center justify-between h-10 mb-4">
                    <div>
                        <h2 className="text-lg font-bold text-textlight dark:text-textdark">{t('EPtitle')}</h2>
                    </div>
                    <div>
                        <button onClick={onClose} className="flex items-center justify-center w-8 h-8 rounded-full bg-itemlight dark:bg-itemdark dark:text-textlight text-textlight dark:hover:text-textdark hover:bg-gray-300 focus:outline-none">
                            <Close/>
                        </button>
                    </div>
                </div>
                <div>
                    {/* main content here */}
                    <div className="w-full">

                        <form onSubmit={editPost}>
                        <div className="shadow sm:overflow-hidden">
                            <div className="px-4 py-5 space-y-6 bg-bglight dark:bg-bgdark sm:p-6">
                                <div className="grid grid-cols-3 gap-6">
                                    <div className="col-span-3 sm:col-span-2">
                                        <label htmlFor="tag" className="block text-sm font-medium text-textlight dark:text-textdark">
                                        {t('EPtopic')}
                                        </label>
                                        <div className="flex mt-1 rounded-md shadow-sm">
                                            <span className="inline-flex items-center px-3 text-sm border border-r-0 border-borderlighthover rounded-l-md bg-itemlight dark:bg-itemdark text-textlight dark:border-borderdark dark:text-textdark">
                                                #
                                            </span>
                                            <input
                                                name={tag}
                                                type="text"
                                                onChange={(e) => setTag(e.target.value)}
                                                className="flex-1 block w-full rounded-none focus:ring-hoverlight focus:border-hoverlight rounded-r-md sm:text-sm dark:bg-itemdark dark:border-borderdark border-borderlighthover placeholder-textlight dark:placeholder-textdark"
                                                placeholder={tag}/>
                                        </div>
                                        <p className="mt-2 text-sm text-textlight dark:text-textdark">
                                            {t('EPtopichelp')}
                                        </p>
                                    </div>
                                </div>

                                <div>
                                    <label htmlFor="postText" className="block text-sm font-medium text-textlight dark:text-textdark">
                                        {t('EPeditpost')}
                                    </label>
                                    <div className="mt-1">
                                        <textarea
                                            name="postText"
                                            rows="5"
                                            onChange={(e) => setPost(e.target.value)}
                                            className="block w-full mt-1 rounded-md shadow-sm focus:ring-hoverlight focus:border-hoverlight sm:text-sm dark:bg-itemdark dark:border-borderdark border-borderlighthover placeholder-textlight dark:placeholder-textdark"
                                            placeholder={post}>
                                        </textarea>
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-textlight dark:text-textdark">
                                        {t('EPeditphoto')}
                                    </label>
                                    <div className="flex justify-center px-6 pt-5 pb-6 mt-2 border-2 border-dashed rounded-md border-borderlighthover dark:border-borderdark">
                                        <div className="space-y-1 text-center">
                                            <svg className="w-12 h-12 mx-auto text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <div className="flex text-sm text-gray-600">
                                                <label htmlFor="file-upload" className="relative font-medium cursor-pointer text-textlight dark:text-textdark hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                                <span>{t('APinput3help1')}</span>
                                                <input onChange={(e) => setFile(e.target.files[0])} accept="image/x-png,image/jpeg" id="file-upload" name="file-upload" type="file" className="sr-only"/>
                                                </label>
                                                <p className="pl-1 text-textlight dark:text-textdark">{t('APinput3help2')}</p>
                                            </div>
                                            <p className="text-xs text-textlight dark:text-textdark">
                                                {t('APinput3help3')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-4 py-3 text-right sm:px-6">
                                <button type="submit" className="inline-flex justify-center px-4 py-2 text-sm font-medium transition-colors duration-200 border rounded-md shadow-sm text-textlight dark:text-textdark bg-itemlight dark:bg-itemdark hover:bg-hoverlight focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:hover:bg-hoverlight hover:text-white dark:hover:text-white border-borderlighthover dark:border-borderdark">
                                {t('EPedit')}
                                </button>
                            </div>
                        </div>
                        </form>

                    </div>

                </div>

            </div>
        </div>,
        document.getElementById('portal')
    )
}
